import { ChangeDetectionStrategy, Component, input, type InputSignal } from '@angular/core';

@Component({
  selector: 'ui-disclosure-panel',
  imports: [],
  templateUrl: './ui-disclosure-panel.component.html',
  styleUrl: './ui-disclosure-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiDisclosurePanelComponent {
  public readonly title: InputSignal<string> = input.required<string>();
  public readonly hint: InputSignal<string | null> = input<string | null>(null);
  public readonly open: InputSignal<boolean> = input<boolean>(false);
}
